import React, { useState } from "react";
import Wrapper from "../Landing/vendor/Wrapper";
import Header from "./sections/Header";
import Benefits from "./sections/Benefits";
import Testimony from "./sections/Testimony";
import Choose from "./sections/Choose";
import Footer from "./sections/Footer";
import TeacherRegister from "../../Component/TeacherRegister/TeacherRegister";
import Modal from "../../UIcomponent/Modal";
import { Redirect } from "react-router-dom";
import { useContext } from "react";
import LocalContext from "../../Context/LocalContetxt";
import Metas from "../../Component/Metas";
import FooterDescription from "../../Component/FooterDescription";
export default function TeacherLanding() {
  const [showForm, setShowForm] = useState(false);
  const hasToken = useContext(LocalContext).hasToken;
  const config = useContext(LocalContext).config;
  const [redirect, setRedirect] = useState(false);
  return (
    <Wrapper direction="rtl">
      {redirect === false &&
        hasToken === true &&
        config &&
        config.role === "Teacher" && <Redirect to="/dashboard" />}
      <Metas
        title="  تدریس زبان| استاد زبان لینگوتاک شوید و از مهارت خود درآمد کسب کنید"
        description="تدریس زبان و کسب درآمد از آموزش زبان کار ساده ای است. کافی است استاد زبان لینگوتاک شوید. برگزاری کلاس با هزینه مدنظر شما و زمانی که شما تعیین می کنید"
      />
      <Header setShowForm={setShowForm} />
      <Benefits />
      <Testimony />
      <Choose />
      <br />

      <FooterDescription
        title="تدریس زبان در لینگوتاک"
        content=" اگر استاد زبان هستید و قصد کسب درآمد از مهارت خود را دارید، لینگوتاک بهترین انتخاب برای شماست. در لینگوتاک تعیین قیمت کلاس‌ها با خودِ شماست، این قابلیت به مدیریت درآمد شما از تدریس خصوصی زبان کمک خواهد کرد.کلاس‌های آنلاین لینگوتاک این امکان را برای شما فراهم کرده است که مکان مناسب تدریس زبان ر خودتان انتخاب کنید. به این ترتیب می‌توانید در زمان‌هایی که از نظر شما مناسب است کلاس آنلاین خود را برگزار کنید. امکان برگزاری کلاس به تعداد دلخواه شما، با بهترین کیفیت و متناسب با برنامه روزانه و هفتگی شما، از دیگر مزیت‌های تدریس زبان در لینگوتاک است. دسترسی به دانشجویان بیشتر به سادگی و در کوتاه‌ترین زمان ممکن، کار تدریس زبان را برای شما آسان و لذت‌بخش خواهد کرد. برگزاری کلاس‌های گروهی، استفاده از پلتفرم و محیط دلخواه شما برای برگزاری کلاس‌های آنلاین از دیگر مزیت‌های استاد زبان بودن در لینگوتاک است. برای آموزش زبان آنلاین و تدریس به عنوان استاد زبان در لینگوتاک به ما بپیوندید."
      />
      {/* <Footer setShowForm={setShowForm} /> */}
      <Modal onCancel={() => setShowForm(false)} visible={showForm}>
        <TeacherRegister setRedirect={setRedirect} redirect={redirect} />
      </Modal>
    </Wrapper>
  );
}
